<script setup lang="ts">
import type { CSSProperties } from 'vue'

type Gap = 'none' | 'x3s' | 'xxs' | 'xs' | 's' | 'm' | 'mm'

withDefaults(
  defineProps<{
    gap?: Gap
    justify?: CSSProperties['justifyContent']
    align?: CSSProperties['alignItems']
  }>(),
  {
    gap: 'none',
    justify: 'flex-start',
    align: 'flex-start',
  }
)
</script>

<template>
  <div
    class="cluster"
    :class="{
      ['gap-' + gap]: gap !== 'none',
    }"
    :style="{ justifyContent: justify, alignItems: align }"
  >
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.cluster {
  display: flex;
  flex-direction: row;

  &.gap-x3s {
    gap: spacingToken.$spacing-x3s;
  }

  &.gap-xxs {
    gap: spacingToken.$spacing-xxs;
  }

  &.gap-xs {
    gap: spacingToken.$spacing-xs;
  }

  &.gap-s {
    gap: spacingToken.$spacing-s;
  }

  &.gap-m {
    gap: spacingToken.$spacing-m;
  }

  &.gap-mm {
    gap: spacingToken.$spacing-mm;
  }
}
</style>
